import {
  ClickAwayListener,
  Popper as MaterialUIPopper,
  PopperPlacementType,
} from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';

import { cn } from '@/src/util/ui';

export const POPPER_TYPES = {
  tooltip: cn('tw-flex tw-rounded-[5px]', 'tw-bg-cfo-black tw-text-white'),
  dropdown: cn(
    'tw-border-[1px] tw-rounded-b-[5px]',
    'tw-bg-white tw-shadow-[3px_4px_5px_0px_rgba(0,0,0,0.06)] '
  ),
};

type PopperProps = {
  popper?: {
    type?: keyof typeof POPPER_TYPES;
    placement?: PopperPlacementType;
    showPopper?: boolean;
    styleClasses?: string;
    content?: React.ReactNode;
  };
  mainClasses?: string;
  onMouseEnter?: (e?: any) => void;
  onMouseLeave?: (e?: any) => void;
  handleShowPopper: (e?: any) => void; // Added function type for handleShowPopper
  children?: React.ReactNode;
  containerRef: React.RefObject<any>;
};

const Popper = ({
  popper = null,
  mainClasses,
  onMouseEnter,
  onMouseLeave,
  handleShowPopper,
  children,
  containerRef,
}: PopperProps) => {
  const popperStyleClasses = popper?.type ? POPPER_TYPES[popper.type] : POPPER_TYPES.dropdown;

  return (
    <div
      className={cn('popper--wrapper', mainClasses)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}

      <MaterialUIPopper
        disablePortal={true}
        open={popper.showPopper}
        anchorEl={containerRef.current}
        placement={(popper.placement as PopperPlacementType) || 'left-start'}
        style={{ zIndex: 100 }}
        className={cn(popperStyleClasses, popper.styleClasses)}
      >
        <ClickAwayListener onClickAway={handleShowPopper}>
          <div className={clsx('popper--container')}>{popper.content}</div>
        </ClickAwayListener>
      </MaterialUIPopper>
    </div>
  );
};

export default Popper;
